/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import { qreq } from "../../shared/qrequest";
import AppActions from "../AppActions";
import BaseCom from "../BaseCom";
import Card from "../Card";
import FormInput from "../FormInput";
import Icon from "../Icon";
import { withParamsAndNavigate } from "../WithParamsAndNavigate";

class PanelTargetManageEdit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            item: {},
            example: {
                name: 'White Blood Cell Count',
                code: 'WBC',
                units: 'x10^3/uL',
                refRange: '4.0-10.0',
                critRefRange: '3.0-12.0'
            }
        }
    }

    componentDidMount() {
        if (this.props.params.id) {
            this.fillItem('/api/target/get/' + this.props.params.id, 'item');
        }
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    submit = async (e) => {
        try {
            e?.preventDefault();
            var j = await qreq.postAsync('/api/target/save', this.state.item);
            if (j.errorCode === 0) {
                this.success('Target saved');
                this.goBack();
            }
            else
                this.alert('Error saving target');
        }
        catch (e) {
            this.alert(e);
        }
    }

    render() {
        return <div className="container-fluid">
            <form onSubmit={this.submit}>
                <h1>Target</h1>
                <Card title="Basic Information">
                    <div className="row">
                        <div className="col-md-5">
                            <FormInput model={this.state.item} name="name" label="Name" required placeholder={this.state.example.name} onChange={this.change} />
                        </div>
                        <div className="col-md-2">
                            <FormInput model={this.state.item} name="code" label="Code" required placeholder={this.state.example.code} onChange={this.change} />
                        </div>
                    </div>
                </Card>

                <Card title="Properties">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="units" label="Units" onChange={this.change} placeholder={this.state.example.units} />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="refRange" label="Reference Range" onChange={this.change} placeholder={this.state.example.refRange} />
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="critRefRange" label="Critial Reference Range" onChange={this.change} placeholder={this.state.example.critRefRange} />
                        </div>
                    </div>
                </Card>

                <Card title="Settings">
                    <div className="row">
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isHidden" label="Hidden" type="switch" onChange={this.change} />
                            <small>Hide this target from the result report.</small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isOptional" label="Optional" type="switch" onChange={this.change} />
                            <small>Make this target optional for the report to be finalized.</small>
                        </div>
                        <div className="col-md-4">
                            <FormInput model={this.state.item} name="isDisabled" label="Disable" type="switch" onChange={this.change} />
                            <small>Disable the target completely from use.</small>
                        </div>
                    </div>
                </Card>
                <AppActions>
                    <button type="submit" className="btn btn-success btn-lg"><Icon icon="faSave" /> Save</button>
                </AppActions>
            </form>
        </div>;
    }
}

export default withParamsAndNavigate(PanelTargetManageEdit);